export default "__VITE_ASSET__b3994997__"